import React from 'react';
import './_configurationBot.scss';
import { injectIntl } from 'react-intl';
import CapButton from '../../CapButton';
import CapRow from '../../CapRow';
import { Tooltip } from '../UtilComponents/Tooltip';

const UserApproveAction = ({
  intl: { formatMessage },
  loading,
  handleSubmit,
  handleApproval,
  localBlockers,
  textCreate,
  textCancel,
}) => {
  localBlockers = Object.values(localBlockers);
  let createButton = (
    <CapButton
      data-testid="approve-button"
      className="user-approve-button"
      onClick={handleApproval}
      disabled={loading || localBlockers.length > 0}
    >
      {textCreate}
    </CapButton>
  );
  if (localBlockers.length > 0) {
    const uniqueBlockers = [...new Set(localBlockers)];
    const tooltipTitle = (
      <ul style={{ paddingTop: '1em', paddingRight: '1.5em' }}>
        {uniqueBlockers.map((blocker, index) => {
          return <li key={index}>{blocker}</li>;
        })}
      </ul>
    );
    createButton = (
      <Tooltip title={tooltipTitle} placement="top">
        <span className="button-disabled-tooltip-wrapper">{createButton}</span>
      </Tooltip>
    );
  }

  return (
    <CapRow type="flex" className="user-approve-container">
      {createButton}
      <CapButton
        type="secondary"
        className="user-approve-button cancel-button"
        onClick={e => handleSubmit(textCancel)}
      >
        {textCancel}
      </CapButton>
    </CapRow>
  );
};

UserApproveAction.defaultProps = {};
export default injectIntl(UserApproveAction);
